import React from 'react';
import { Modal, Typography, Row, Col, List } from 'antd';
import moment from 'moment';
import { CustomGridTable } from '../../../blueplanitUtils/CustomGridTable';
import { useLocation } from 'react-router-dom';
import { S3ACCESSURL } from '../../../databucket';
const { Title } = Typography;

const AssetWorkHistory = ({ open, onClose, selectedAsset }) => {
  const location = useLocation();
  const isWarrantiesRoute = location.pathname === '/ListOfWarranties';
  const attachmentsToShow = isWarrantiesRoute
    ? selectedAsset?.warrantyAttachments?.filter(file => file.status)
    : selectedAsset?.attachments?.filter(file => file.status);
  const changedFields = isWarrantiesRoute
    ? ['warrantyDuration']
    : [
      'description', 'assetTagId', 'purchasedFrom', 'purchaseDate',
      'cost', 'brand', 'model', 'category', 'department',
      'checkInStatus', 'checkOutReason', 'expectedCheckInDate',
      'checkOutDate', 'attachments', 'warrantyAttachments'
    ];

  const formatValue = (value) => {
    if (typeof value === 'string' && value.length > 40) {
      return `${value.substring(0, 40)}...`;
    }
    return value !== null && value !== undefined && value !== '' ? value : '—';

  };

  const columns = [
    {
      title: 'User Name',
      dataIndex: 'editedBy',
      key: 'editedBy',
      width: 150,
    },
    {
      title: "Updated Time",
      dataIndex: "editedAt",
      key: "editedAt",
      render: (value) => {
        if (!value) return "—";

        // Try parsing as number first
        const num = Number(value);
        if (!isNaN(num)) {
          return moment(num).format("DD/MM/YYYY HH:mm");
        }

        // Fallback to normal date parsing
        return moment(value).isValid()
          ? moment(value).format("DD/MM/YYYY HH:mm")
          : "—";
      }
    },


    {
      title: 'Action',
      key: 'action',
      width: 120,
      render: (_, record) => {
        const changeFields = record.changes.map(c => c.field);

        if (!isWarrantiesRoute && changeFields.includes('checkInStatus')) {
          const checkInChange = record.changes.find(c => c.field === 'checkInStatus');
          return checkInChange.newValue === 'true' ? 'Checked In' : 'Checked Out';
        }
 
        return 'Asset Edit';
      }
    },

    ...changedFields.map((field) => ({
      title: field.charAt(0).toUpperCase() + field.slice(1),
      key: field,
      width: field === 'attachments' ? 220 : 160,
      render: (_, record) => {
        const change = record.changes.find((c) => c.field === field);
        if (!change) return <span>No Change</span>;

        const formatDate = (val) => {
          if (!val) return '—';
          let num = Number(val);
          if (!isNaN(num)) {
            if (num < 1e12) num *= 1000;
            return moment(num).format('DD/MM/YYYY');
          }
          return moment(val).isValid() ? moment(val).format('DD/MM/YYYY') : '—';
        };


        if (field === 'attachments') {
          const oldValue = change.oldValue || '';
          const newValue = change.newValue || '';

          if (
            oldValue === newValue ||
            (oldValue === '—' && !newValue) ||
            (!oldValue && newValue === '—')
          ) {
            return <span>No Change</span>;
          }

          return (
            <div>
              <span style={{ color: 'red' }}>{formatValue(oldValue)}</span>
              <span style={{ margin: '0 4px' }}>→</span>
              <span style={{ color: 'green' }}>{formatValue(newValue)}</span>
            </div>
          );
        }

        const dateFields = ['expectedCheckInDate', 'checkOutDate','purchaseDate'];
        const oldValue = dateFields.includes(field)
          ? formatDate(change.oldValue)
          : formatValue(change.oldValue);

        const newValue = dateFields.includes(field)
          ? formatDate(change.newValue)
          : formatValue(change.newValue);


        if (oldValue === newValue) return <span>No Change</span>;

        return (
          <div>
            <span>{oldValue}</span>
            <span style={{ margin: '0 4px' }}>→</span>
            <span>{newValue}</span>
          </div>
        );
      },
    }))
  ];

  return (
    <Modal
      open={open}
      title="Asset Details"
      footer={null}
      onCancel={onClose}
      width="90%"
      style={{ top: 80 }}
    >
      {selectedAsset && (
        <div style={{ marginBottom: 32, padding: 16, background: '#f9f9f9', borderRadius: 8 }}>
          <Row gutter={[16, 12]}>
            <Col span={6}><strong>Description:</strong></Col>
            <Col span={6}>{selectedAsset.description || '—'}</Col>

            <Col span={6}><strong>Asset Tag ID:</strong></Col>
            <Col span={6}>{selectedAsset.assetTagId || '—'}</Col>
            <Col span={6}><strong>Product Name:</strong></Col>
            <Col span={6}>{selectedAsset.productName || '—'}</Col>

            <Col span={6}><strong>Purchased From:</strong></Col>
            <Col span={6}>{selectedAsset.purchasedFrom || '—'}</Col>

            <Col span={6}><strong>Purchase Date:</strong></Col>
            <Col span={6}>
              {selectedAsset.purchaseDate
                ? moment(Number(selectedAsset.purchaseDate)).isValid()
                  ? moment(Number(selectedAsset.purchaseDate)).format('DD/MM/YYYY')
                  : moment(selectedAsset.purchaseDate, moment.ISO_8601, true).isValid()
                    ? moment(selectedAsset.purchaseDate).format('DD/MM/YYYY')
                    : '—'
                : '—'}
            </Col>
            <Col span={6}><strong>Cost:</strong></Col>
            <Col span={6}>
              {selectedAsset.cost !== null && selectedAsset.cost !== undefined
                ? `₹ ${selectedAsset.cost}`
                : '—'}
            </Col>

            <Col span={6}><strong>Brand:</strong></Col>
            <Col span={6}>{selectedAsset.brand || '—'}</Col>

            <Col span={6}><strong>Model:</strong></Col>
            <Col span={6}>{selectedAsset.model || '—'}</Col>

            <Col span={6}><strong>Category:</strong></Col>
            <Col span={6}>{selectedAsset.category || '—'}</Col>

            <Col span={6}><strong>Department:</strong></Col>
            <Col span={6}>{selectedAsset.department || '—'}</Col>

            <Col span={6}><strong>Created By:</strong></Col>
            <Col span={6}>{selectedAsset.createdBy || '—'}</Col>
            {isWarrantiesRoute && (
              <>
                <Col span={6}><strong>Warranty Duration(in Months):</strong></Col>
                <Col span={6}>{selectedAsset.warrantyDuration || '—'}</Col>
              </>
            )}

            <Col span={6}><strong>Attachments:</strong></Col>
            <Col span={6}>
              {attachmentsToShow?.length > 0 ? (
                <List
                  size="small"
                  dataSource={attachmentsToShow}
                  renderItem={(file, idx) => (
                    <List.Item key={idx} style={{ border: 'none', padding: '4px 0' }}>
                      <a
                        href={S3ACCESSURL + file.data}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {file.filename}
                      </a>
                    </List.Item>
                  )}
                />
              ) : (
                <span>No Attachments</span>
              )}
            </Col>


          </Row>
        </div>
      )}

      <Title level={4} style={{ marginBottom: 16 }}>Update History</Title>
      <CustomGridTable
        dataSource={isWarrantiesRoute ? [] : selectedAsset?.updateHistory || []}
        columns={columns}
        Id="asset-work-history-table"
        rowKey={(record, index) => index}
        pagination={{ pageSize: 5 }}
        scroll={{ x: 'max-content' }}
        bordered
        size="small"
        locale={{ emptyText: 'No edit history available' }}
      />
    </Modal>
  );
};

export default AssetWorkHistory;
